import React from "react";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { observer } from "mobx-react-lite";
import "./ExcludedPlayersList.css";
import { ClickableText } from "../clickableText/ClickableText";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";

interface ExcludedPlayersListProps {
  onExcludeMore: () => void;
}

export const ExcludedPlayersList: React.FC<ExcludedPlayersListProps> = observer(
  ({ onExcludeMore }) => {
    const selectCircleStore = useSelectCircleStore();

    const getInitials = (name: string) => {
      return name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    };

    return (
      <>
        {selectCircleStore.excludedPlayers.length > 0 ? (
          <div className="excluded-players-container">
            <div className="excluded-players-scroll-container">
              <div className="excluded-players-list">
                {selectCircleStore.excludedPlayers.map((player) => (
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}>
                    <div key={player.userId} className="player-avatar">
                      {player.userImageUrl ? (
                        <img
                          src={player.userImageUrl}
                          alt={player.name}
                          className="excluded-player-image"
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                            e.currentTarget.parentElement!.dataset.initials =
                              getInitials(player.name);
                          }}
                        />
                      ) : (
                        getInitials(player.name)
                      )}
                    </div>
                    <div className="exclude-player-name">
                      {player.name.length > 15
                        ? `${player.name.slice(0, 15)}...`
                        : player.name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="excluded-players-info">
              <TCText
                style={{ fontWeight: 600, fontSize: 12, color: "white" }}
                value={`${selectCircleStore.excludedPlayers.length} Excluded players`}
              />
              <ClickableText
                textStyle={{
                  fontWeight: 500,
                  fontSize: 12,
                  color: Colors.gold,
                  //   marginTop: -5,
                }}
                text={"Exclude more player"}
                onClick={onExcludeMore}
              />
            </div>
          </div>
        ) : null}
      </>
    );
  }
);
